import React, { useEffect, useState } from "react";
import styles from "./BusinessDetails.module.scss";
import NavBar from "../navbar/NavBar";
import FilterModal from "../filterConfig/FilterModal";
import dayjs, { Dayjs } from "dayjs";
import {
	dateNow,
	sevenDaysAgo,
	thirtyDaysAgo,
	startOfYear,
	endOfYear,
} from "../../util/datefunction";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import axios from "axios";
import { useDispatch } from "react-redux";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import {
	ColumnBusinessModule,
	BusinessModuleData,
	RecentSettlementModuleData,
	ColumnRecentSettlementModule,
} from "../../types/BusinessModule";
import PaginationTable from "../paginatedTable/pagination-table";
import TableHeader from "../TableHeader/TableHeader";
import StatusView from "../StatusView/StatusView";
import { useHistory, useParams } from "react-router-dom";
import { numberWithCommas } from "../../util/formatNumber";

function RecentSettlement() {
	const { id } = useParams<any>();

	const [tableRow, setTableRow] = useState<any[]>();
	const [businesses, setBusinesses] = useState<any>();
	const [contentAction, setContentAction] = useState<any>({});
	const history = useHistory();

	const dispatch = useDispatch();
	//PAGINATION
	const [pageNumber, setPageNumber] = React.useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(20);
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);

	//FILTERING
	const [value, setValue] = useState("");
	const [dropdown, setDropdown] = useState(false);
	const [eventDate, setEventDate] = useState("");
	const [fromDate, setFromDate] = useState<Dayjs | null | string>("");
	const [toDate, setToDate] = useState<Dayjs | null | string>("");
	const [country, setCountry] = useState("");
	const [status, setStatus] = useState("");
	const [email, setEmail] = useState("");

	const [bearer, setBearer] = useState(false);

	const clearHandler = () => {
		setEventDate("");
		setFromDate("");
		setToDate("");
		setCountry("");
		setStatus("");
		setDropdown(false);
		setBearer(true);
	};

	useEffect(() => {
		if (eventDate === "today") {
			setFromDate(dateNow);
			setToDate(dateNow);
		} else if (eventDate === "last7days") {
			setFromDate(sevenDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "last30days") {
			setFromDate(thirtyDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "oneyear") {
			setFromDate(startOfYear);
			setToDate(endOfYear);
		} else {
			setFromDate("");
			setToDate("");
		}
	}, [eventDate]);

	const filteredArray = [
		{
			name: "Status",
			value: status,
			setValue: setStatus,
			selective: [{ name: "YES" }, { name: "NO" }],
		},
	];

	const fetchBusinesses = async () => {
		dispatch(openLoader());
		try {
			const data = await axios.get(`/v1/business/${id}/recent/settlement`);
			setBusinesses(data?.data);
			setBearer(false);
			dispatch(closeLoader());
		} catch (error: any) {
			dispatch(closeLoader());
			const message = error?.response?.data?.message;
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent: message,
						toastType: "error",
					})
				)
			);
		}
	};

	useEffect(() => {
		fetchBusinesses();
	}, [bearer, value, pageNumber, rowsPerPage]);

	const dataBusinesses = () => {
		const tempArr: RecentSettlementModuleData[] = [];
		businesses?.recentSettlement
			?.slice(0)
			.reverse()
			.forEach((recent: any, index: number) => {
				return tempArr.push({
					tradingname: recent?.business?.tradingname ?? "N/A",
					settlementtype: recent?.settlementtype ?? "N/A",
					amount: recent?.amount
						? `${recent.currency} ${numberWithCommas(recent.amount)}`
						: "N/A",
					chargeamount: recent?.chargeamount
						? `${recent.currency} ${numberWithCommas(recent.chargeamount)}`
						: "N/A",
					fee: recent?.fee
						? `${recent.currency} ${numberWithCommas(recent.fee)}`
						: "N/A",
					settlementdate: recent?.settlementdate ?? "N/A",
					// businessemail: business?.businessemail,
					// country: business?.country,
					// islive: business?.islive ? "Live" : "Test",
					// status: (
					// 	<StatusView
					// 		status={business?.status === 0 ? "InActive" : "Active"}
					// 		green="Active"
					// 		red="InActive"
					// 	/>
					// ),
					// createdat: business?.createdat,
					// id: business?.merchantaccountid,
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataBusinesses());
	}, [businesses?.recentSettlement]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				background: "#EFF3F8",
				height: "100%",
				overflowY: "scroll",
			}}
		>
			<NavBar name="Recent Settlements" />
			<div className={styles.containerBusiness}>
				<div className={styles.containerHeader}>
					<PaginationTable
						data={tableRow ? tableRow : []}
						columns={
							ColumnRecentSettlementModule ? ColumnRecentSettlementModule : []
						}
						emptyPlaceHolder={
							businesses?.recentSettlement?.length == 0
								? "No record found"
								: "Loading..."
						}
						value={value}
						total={businesses?.recentSettlement?.length}
						totalPage={Math.ceil(
							(businesses?.recentSettlement?.length || 0) / rowsPerPage
						)}
						// {businesses?.recentSettlement?.length}
						pageNumber={pageNumber}
						setPageNumber={setPageNumber}
						nextPage={nextPage}
						setNextPage={setNextPage}
						previousPage={previousPage}
						setPreviousPage={setPreviousPage}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						clickAction={false}
						setContentAction={setContentAction}
						recent={false}
					/>
				</div>
			</div>
		</div>
	);
}

export default RecentSettlement;
